const beforeModalOpen = () => (document.getElementsByTagName('body')[0].style.overflow = 'hidden');

const beforeModalClose = () => (document.getElementsByTagName('body')[0].style.overflow = 'auto');

export { beforeModalOpen, beforeModalClose };
